module.exports = __webpack_public_path__ + "9813ff3cb52f55bcb487cccf79a6a8d4.svg";